import React from "react";
import { Grid } from "@material-ui/core";
import logo from "../../resources/fg-logo.svg";
import facebook from "../../resources/Facebook.png";
import instagram from "../../resources/Instagram.png";
import twitter from "../../resources/Twitter.png";
import "./Footer.css";

function Footer() {
  return (
    <Grid
      container
      direction="row"
      justify="center"
      alignItems="center"
      maxWidth="sm"
      className="footer"
    >
      <Grid item xs={12} md={6} lg={3} className="footer__one">
        <div className="footer__one--logo">
          <img src={logo} />
        </div>
        <div className="footer__one--p">
          <p>
            Lorem Ipsum has been the industry's <br /> standard dummy text ever
            since the 1500s,
          </p>
        </div>
        <div className="footer__one--social">
          <img src={facebook} />
          <img src={twitter} />
          <img src={instagram} />
        </div>
        <div className="footer__one--copy">
          <p>©Gpmesh 2020. All rights reserved</p>
        </div>
      </Grid>

      <Grid item xs={12} md={6} lg={3} className="footer__two">
        <h4 className="footer__two--heading">About</h4>
        <ul className="footer__two--list">
          <li>Team</li>
          <li>Mission</li>
          <li>History</li>
          <li>Press</li>
          <li>Values</li>
          <li>Contact Us</li>
        </ul>
      </Grid>

      <Grid item xs={12} md={6} lg={3} className="footer__three">
        <h4 className="footer__three--heading">Resources</h4>
        <ul className="footer__three--list">
          <li>Blog</li>
          <li>FAQ</li>
          <li>Tutorials</li>
          <li>Affiliation</li>
          <li>Privacy Policy</li>
          <li>Terms of Service</li>
        </ul>
      </Grid>

      <Grid item xs={12} md={6} lg={3} className="footer__four">
        <h4 className="footer__four--heading">Menu</h4>
        <ul className="footer__four--list">
          <li>How does it work?</li>
          <li>Prices</li>
          <li>Use Cases</li>
          <li>&nbsp;</li>
          <li>&nbsp;</li>
          <li>&nbsp;</li>
        </ul>
      </Grid>
    </Grid>
  );
}

export default Footer;
